import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{						
						case 'anularRegistroFtn':
							await this.updateDataForm({state: 'info_ingresos/anulado', data: 1})
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: this.dataForm[this.namePath].info_ingresos.nota_delete, 
									tablaPost: ['info_ingresos'],
									tablaDelete:[]
								}
							}) 
							 
						break;
						case 'descargarAflFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: null, 
									tablaPost: ['info_ingresos'],
									tablaDelete:[]
								}
							}) 
							 
						break;	
						case 'registroFtn': 
						await this.updateDataForm({state: 'info_ingresos/fecha', data : this.fecha().fecha.minHoy})
						await this.updateDataPost({ 
							data: { 
								data: [],
								route: 'save_all', 
								tablaAuditar: true, 
								notaDelete: null, 
								tablaPost: ['info_ingresos'],
								tablaDelete:[]
							}
						}) 
						break;
					}
				}

				let dataSave = await this.save(event.save)

				if(event.ftn==='registroFtn')
				{
					window.open( this.url+'/api/pdf/registro?id='+dataSave.ids.info_ingresos.toString()+'&token='+this.token,'_blank')	
				
				}
							
				const await30 =   this.getDataGet({route: 'get_aflregistros', data: {inicial: this.filter.inicial, final: this.filter.final, others: []}})
				// frotend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
				const await31 =  this.resetDataIndex()
				const await32 =  this.resetGlobal({state: 'openModal'})
				const await33 =  this.resetDataForm()
				const await34 =  this.resetGlobal({state: 'saveConfig/capa'})
				await Promise.all([await30,await31,await32,await33,await34]) 
			}
			catch{

			}			
		}		
	},
}
